import { Card, CardContent, Grid2 as Grid, Stack, Typography } from '@mui/material';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBagOutlined';
import SavingsIcon from '@mui/icons-material/SavingsOutlined';
import VerifiedIcon from '@mui/icons-material/VerifiedOutlined';
import { useTranslation } from 'react-i18next';
import { Section } from '@/components/Section';
import { setting, usePublicContent } from './use-public-content';
import { useSectionCopy } from './use-section-copy';

const PILLARS = [
  { key: 'direct', Icon: ShoppingBagIcon },
  { key: 'savings', Icon: SavingsIcon },
  { key: 'transparent', Icon: VerifiedIcon },
] as const;

/** The three value propositions carried over from the flyer. */
export function Pillars() {
  const { t } = useTranslation();
  const { settings } = usePublicContent();
  const percent = setting(settings, 'company.savingsPercent', '40');
  const copy = useSectionCopy('pillars', { title: t('pillars.title') });

  return (
    <Section id="vorteile" tone="muted" eyebrow={copy.eyebrow} title={copy.title} subtitle={copy.subtitle}>
      <Grid container spacing={3}>
        {PILLARS.map(({ key, Icon }) => (
          <Grid key={key} size={{ xs: 12, sm: 6, md: 4 }}>
            <Card sx={{ height: '100%', bgcolor: 'background.paper' }}>
              <CardContent sx={{ p: { xs: 3, md: 3.5 } }}>
                <Stack spacing={2}>
                  <Icon sx={{ fontSize: 30, color: 'text.primary' }} />
                  <Typography variant="h4" component="h3">
                    {t(`pillars.${key}.title`, { percent })}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {t(`pillars.${key}.body`, { percent })}
                  </Typography>
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Section>
  );
}
